<template>
  <div ref="el" class="animated-container-scroll">
    <slot />
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  start: { type: String, default: 'top 85%' },
  end: { type: String, default: 'bottom top' },
  markers: { type: Boolean, default: false },
  delay: { type: Number, default: 0 },
  stagger: { type: Number, default: 0 },
  scrub: { type: Number, default: 1.75 },
  breakpoints: { type: Array, default: () => [] },
})

const el = ref(null)
let ctx: any = null

onMounted(() => {
  useGsap.delayedCall(props.delay, () => {
    initAnimation()
  })
})

onUnmounted(() => {
  ctx?.revert()
})

const initAnimation = () => {
  ctx = useGsap.context((self) => {
    if (!self || !self.selector) return
    const scrollUp = self.selector('.scroll-up')

    const tl = useGsap.timeline({
      scrollTrigger: {
        trigger: el.value,
        start: props.start,
        end: props.end,
        markers: props.markers,
        scrub: props.scrub,
      },
    })

    if (scrollUp.length === 0) return

    const mm = useGsap.matchMedia()
    const y = -50

    // for each breakpoint
    props.breakpoints.forEach((item) => {
      mm.add(`(${item.breakpoint})`, () => {
        // One column add animation to all elements
        if (item.columns === 1) {
          tl.add(
            useGsap.to(scrollUp, {
              autoAlpha: 1,
              y,
              stagger: props.stagger,
            })
          )
        }

        tl.add(
          useGsap.to(scrollUp, {
            autoAlpha: 1,
            y,
            stagger: props.stagger,
            modifiers: {
              y: (y, target) => {
                const index = parseInt(target.getAttribute('data-index'), 10)
                return (index % item.columns) % 2 === 0 ? 0 : y
              },
            },
          })
        )
      })
    })
  }, el.value)
}
</script>

<style>
body:not(.live-preview-active) {
  .animated-container-scroll {
    .scroll-up {
      transform-box: fill-box;
      transform: translateY(50px);
    }
  }
}
</style>
